/**
 * Print prep for the recipe page (PRINT 1, Alex 11/03).
 *
 * The print layout itself is pure CSS (assets/section-main-recipe.css), so
 * printing works with JavaScript disabled. This file exists for one edge case
 * only: a photo that has not finished decoding when the print dialog
 * snapshots the page prints as an empty box. The hero is already
 * `loading="eager"` + `fetchpriority="high"`, so in practice there is nothing
 * to do — but if someone hits Cmd/Ctrl+P in the first moments after load, ask
 * the browser to decode it now rather than later.
 *
 * Degrades harmlessly in every way: no hero, no `beforeprint` support, or a
 * `decode()` rejection (a broken image URL) all just leave the page as it was.
 */
(function () {
  var hero = document.querySelector('.recipe-page__hero');
  if (!hero || !window.addEventListener) return;

  window.addEventListener('beforeprint', function () {
    if (hero.loading !== 'eager') hero.loading = 'eager';
    if (!hero.complete && typeof hero.decode === 'function') {
      hero.decode().catch(function () {});
    }
  });
})();
